import React from 'react'
import { useSelector } from 'react-redux'
import { t } from 'ttag'

import { AuthButton } from 'components/auth/common/AuthButton/AuthButton'
import { Form } from 'components/shared/Form/Form'
import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'

import { getUser } from 'ducks/auth'
import { getLocation } from 'ducks/router'
import { useNewPasswordForm } from './hooks'
import { PASSWORD_FIELD } from './model'

import styles from './../Form.module.scss'

export const NewPasswordForm = () => {
  const { error } = useSelector(getUser)
  const location = useSelector(getLocation)

  const {
    payload: { token = '', uidb64: uid },
  } = location

  const { state, handlers } = useNewPasswordForm({ token, uid })

  const { control, formState } = state
  const { handleFormSubmit } = handlers

  const hasUidOrTokenError =
    error != null &&
    (Object.hasOwn(error, 'token') || Object.hasOwn(error, 'uid'))
  const hasPasswordError =
    error != null && Object.hasOwn(error, 'new_password2')
  const hasInvalidUidOrToken =
    formState.isSubmitSuccessful && hasUidOrTokenError
  const hasInvalidPassword = formState.isSubmitSuccessful && hasPasswordError

  if (!token) {
    return (
      <>
        <h1 className={styles.title}>{t`Password reset complete`}</h1>
        <p className={styles.text}>
          {t`Your password has been set. You may go ahead and log in now.`}
        </p>
      </>
    )
  }

  return (
    <>
      <h1 className={styles.title}>{t`Enter new password`}</h1>
      <p className={styles.text}>{t`Please enter your new password.`}</p>
      <MessageAlert
        className={styles.alert}
        message={
          hasInvalidPassword
            ? t`Password is too common.`
            : t`Password cannot be changed. Please make sure that you visited proper url.`
        }
        size="medium"
        variant="error"
        isInitialised={hasInvalidUidOrToken || hasInvalidPassword}
      />
      <Form className={styles.form}>
        <Form.Field
          error={formState.errors[PASSWORD_FIELD]?.message}
          field="input"
          hint={t`Password must contain at least 8 characters.`}
          label={t`New password`}
          name={PASSWORD_FIELD}
          type="password"
          {...{ control }}
        />
      </Form>
      <AuthButton
        className={styles.button}
        label={t`Change my password`}
        variant="filled"
        onClick={handleFormSubmit}
      />
    </>
  )
}
